import { VimeoFrame } from "src/utils/fw";
import IBM from "./modals/IBM";

export default {
    background: "https://assets.swoogo.com/uploads/full/3032641-652596fcd17eb.png",
    links: [
        {
            label: "Huawei Demo", 
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="873868370?h=12427b6298&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"/>,
            width: "5%",
            height: "10.6%",
            left: "8.2%",
            top: "16.8%",
            cursor: "pointer"
        },
        {
            label: "Huawei Website", 
            href: "https://www.huawei.com/en/?ic_medium=direct&ic_source=surlent",
            width: "19.6%",
            height: "10.7%",
            left: "16.3%",
            top: "22.2%",
            cursor: "pointer",
            target: "_blank"
        },
        {
            label: "Huawei Video Screen", 
            modal: <VimeoFrame vidId="876793026?h=7e24d22f9a&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479" wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} />,
            width: "9.4%",
            height: "10.3%",
            left: "9.6%",
            top: "49.7%",
            cursor: "pointer"
        },
        {
            label: "Huawei PDF", 
            href: "https://assets.swoogo.com/uploads/3043506-6527f1a284d17.pdf",
            width: "6.1%",
            height: "9.7%",
            left: "11.3%",
            top: "64.4%",
            cursor: "pointer",
            target: "_blank"
        },
        {
            label: "Huawei Logo", 
            href: "https://www.huawei.com/en/?ic_medium=direct&ic_source=surlent",
            width: "5%",
            height: "9%",
            left: "39.3%",
            top: "35.6%",
            cursor: "pointer"
        },
        {
            label: "Huawei PDF 2", 
            href: "https://www.huawei.com/en/?ic_medium=direct&ic_source=surlent",
            width: "6.9%",
            height: "11%",
            left: "30.6%",
            top: "66.5%",
            cursor: "pointer",
            target:"_blank"
        },
        {
            label: "Huawei - Contact Us", 
            href: "mailto:hcstc-brussels@huawei.com",
            isExternal: true,
            width: "6.1%",
            height: "10.6%",
            left: "38%",
            top: "66.7%",
            cursor: "pointer",
            target: "_blank"
        },
        {
            label: "IBM Logo", 
            href: "https://www.ibm.com",
            width: "5.2%",
            height: "7.8%",
            left: "56.1%",
            top: "25.7%",
            cursor: "pointer",
            target:"_blank"

        },
        {
            label: "IBM Demo", 
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="873866455?h=e73f856974&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"/>,
            width: "5.3%",
            height: "10.5%",
            left: "68.1%",
            top: "16.7%",
            cursor: "pointer"
        },
        {
            label: "IBM Security Logo", 
            href: "https://www.ibm.com/security",
            width: "15.6%",
            height: "9.3%",
            left: "77.8%",
            top: "21.5%",
            cursor: "pointer",
            target:"_blank"
        },
        {
            label: "IBM Definitive Guide to Ransomware PDF", 
            href: "https://assets.swoogo.com/uploads/3042995-6527be1895547.pdf",
            width: "4.6%",
            height: "12.1%",
            left: "63.7%",
            top: "65%",
            cursor: "pointer",
            target:"_blank"
        },
        {
            label: "IBM Cost of a Data Breach Report 2023", 
            href: "https://assets.swoogo.com/uploads/3042996-6527be1abaf43.pdf",
            width: "4.2%",
            height: "11.6%",
            left: "68.5%",
            top: "65.3%",
            cursor: "pointer",
            target:"_blank"
        },
        {
            label: "IBM - Contact Us", 
            href: "mailto:Johcolln@ie.ibm.com",
            width: "7.8%",
            height: "12.6%",
            left: "83.5%",
            top: "33.3%",
            isExternal: true,
            cursor: "pointer"
        },
        {
            label: "IBM Video", 
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="873865807?h=70baa46e8b&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"/>,
            width: "9.1%",
            height: "10.7%",
            left: "82.9%",
            top: "48.4%",
            cursor: "pointer"
        },
        {
            label: "Previous Room",
            href: "/exhibition-hall-diamond",
            width: "17%",
            height: "8%",
            left: "24%",
            top: "89.5%",
        },
        {
            label: "Next Room",
            href: "/exhibition-hall-gold",
            width: "17.0%",
            height: "8%",
            left: "58.9%",
            top: "89.6%",
        },
        {
            label: "Back To Main Hall",
            href: "/exhibition-hall",
            width: "18.2%",
            height: "8%",
            left: "41%",
            top: "89.3%",
        },
    ],
    extras: <IBM roomName="IBM-boothroom"/>,
    name: "exhibition-hall-platinum"
}